module.exports = __webpack_public_path__ + "media/images/no_content.icon.responses.new-54294770.svg";